export default class Photo {
  constructor (photo) {
    this.id = photo.id
    this.name = photo.name
    this.imageUrl = photo.imageUrl
  }
}
